export enum AfterDoneResult {
  saved = 'saved',
  cancelled = 'cancelled',
}
